import { createStyles, makeStyles } from '@material-ui/core';
import React from 'react';
import { Typography } from '../..';
const useStyles = makeStyles((theme) => createStyles({
    root: {
        color: theme.palette.text.secondary,
        backgroundColor: theme.palette.divider,
        padding: theme.spacing(1, 1),
        borderRadius: 300,
        display: 'inline-flex',
        alignItems: 'center',
    },
}));
const GreyIconWrapper = ({ children }) => {
    const classes = useStyles();
    return (React.createElement(Typography, { classes: classes, variant: "body1" }, children));
};
export default GreyIconWrapper;
//# sourceMappingURL=GreyIconWrapper.js.map